module.exports = __webpack_public_path__ + "assets/img/banner2.7486710d.png";